import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=09051be7&scoped=true"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09051be7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09051be7')) {
      api.createRecord('09051be7', component.options)
    } else {
      api.reload('09051be7', component.options)
    }
    module.hot.accept("./AddCoupon.vue?vue&type=template&id=09051be7&scoped=true", function () {
      api.rerender('09051be7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/AddCoupon.vue"
export default component.exports